<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FDkqfI/tc-custom/9781466869691.jpg?1731883366160" alt="This image is the cover for the book Black Sabbath"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Sabbath
      </h1>
      <p class="bookDescription body article font2">
        <p>Decades before reality television was invented, Ozzy Osbourne was subversive and dark. Ozzy was the singer in the heavy metal band Black Sabbath, and they meant business. In an era when rock bands were measured by how 'heavy' they were, no one was weightier than Black Sabbath. All four founding members of the original Black Sabbath grew up within half-a-mile of each other in a tiny Birmingham suburb. Though all shared a deep love of music--The Beatles for Ozzy, the Mothers of Invention for Geezer, the Shadows and Chet Atkins for Iommi, and Gene Kruppa for Ward— they formed their group "as the quickest way out of the slums." This is the story of how they made that dream come true--and how it then turned into a nightmare for all of them. At the height of their fame, Sabbath discovered they'd been so badly ripped off by their managers they didn't even own their own songs. They looked for salvation from Don Arden—an even more notorious gangster figure, who resurrected their career but still left them indebted to him, financially and personally. It finally came to a head when in 1979 they sacked Ozzy: "For being too out of control--even for us," as Bill Ward put it. The next fifteen years were a war between the post-Ozzy Sabbath and Ozzy himself, whose solo career overshadowed Sabbath so much that a reunion was entirely on his terms. Or rather, those of his wife and manager—to add a further bitter twist for Sabbath, daughter of Don Arden —Sharon Osbourne.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mick Wall
      </h2>
      
      <p class="authorDescription body article"><P>MICK WALL is the UK's best-known rock writer.  He is also a TV and radio broadcaster.  His work has appeared in a variety of publications, including Classic Rock, Mojo and the London Times.  He has written a dozen rock biographies, including books on Led Zeppelin, Guns ‘n' Roses and Metallica. He lives in England.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?178b7103